import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "start",
    "resume",
    "pause",
    "stop",
    "fileInput",
    "progressContainer",
  ]

  recording(event) {
    if (event.type === "recording") {
      this.fileInputTarget.classList.add("hidden");
      if (this.hasStartTarget) {
        this.startTarget.classList.add("hidden");
      }
      this.isRecordtarted = true;
      this.stopTarget.classList.remove("hidden")
    }
    this.#modifyScreen({ isDisabled: true });
  }

  pause() {
    this.#modifyScreen({ isDisabled: false });
  }

  stop() {
    this.fileInputTarget.form.classList.add("hidden");
    this.progressContainerTarget.classList.remove("hidden");
  }

  handleRecording(event) {
    const status = event.detail.status
    if (status === "started") {
      this.recording(event)
    } else if (status === "paused") {
      this.pause();
    } else {
      this.stop();
    }
  }

  #modifyScreen({ isDisabled }) {
    this.resumeTarget.classList.toggle("hidden", isDisabled);
    this.pauseTarget.classList.toggle("hidden", !isDisabled);
    this.stopTarget.disabled = isDisabled;
  }
}
